import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import GroupReportsWrapper from "./GroupReportsWrapper.js";
import {
  generateOriginalValue,
  handleNumDisplay,
} from "../Reports/utils/ReportUtils";
import i18n from "../../modules/Auth/pages/i18n.js";
import { useTranslation } from "react-i18next";

function GroupTransferReport(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);

  const columns = [
    { field: "hotelId", headerName: `${t("Hotel ID")}`, dataType: "varchar", checkboxSelection: true, headerCheckboxSelection: true },
    { field: "hotelName", headerName: `${t("Hotel Name")}`, dataType: "varchar" },
    { field: "bookingId", headerName: `${t("Booking ID")}`, dataType: "varchar" },
    { field: "sfPaymentId", headerName: `${t("SF Payment ID")}`, dataType: "varchar" },
    { field: "paymentId", headerName: `${t("Payment ID")}`, dataType: "varchar" },
    { field: "transferId", headerName: `${t("Transfer ID")}`, dataType: "varchar" },
    { field: "pgGatewayName", headerName: `${t("Gateway")}`, dataType: "varchar" },
    {
      field: "paymentAmount",
      headerName: `${t("Payment Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "paymentAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "transferAmount",
      headerName: `${t("Transfer Amount")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "transferAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "pmGatewayFee",
      headerName: `${t("Gateway Fee")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "pmGatewayFee"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "sfCommissionAmount",
      headerName: `${t("SF Commission")}`,
      dataType: "float",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "sfCommissionAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "commissionPerc",
      headerName: `${t("Commission %")}`,
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "commissionPerc"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    { field: "commissionType", headerName: `${t("Commission Type")}`, dataType: "varchar" },
    { field: "processedByStayflexi", headerName: `${t("Processed By Stayflexi")}`, dataType: "varchar" },
    { field: "paymentType", headerName: `${t("Payment Type")}`, dataType: "varchar" },
    { field: "moduleSource", headerName: `${t("Module Source")}`, dataType: "varchar" },
    { field: "currency", headerName: `${t("Currency")}`, dataType: "varchar" },
    { field: "paymentBy", headerName: `${t("Payment By")}`, dataType: "varchar" },
    { field: "tranferStatus", headerName: `${t("Transfer Status")}`, dataType: "varchar" },
    { field: "onHold", headerName: `${t("On Hold")}`, dataType: "varchar" },
    { field: "onHoldUntil", headerName: `${t("Settlement Date")}`, dataType: "date" },
    { field: "paymentDate", headerName: `${t("Payment Date")}`, dataType: "date" },
    { field: "transferDate", headerName: `${t("Transfer Date")}`, dataType: "date" },
  ];

  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params) {
    const result = {};
    for (let i = 0; i < columns.length; i++) {
      if (["integer", "float"].includes(columns[i].dataType)) {
        result[columns[i].field] = 0;
      }
    }

    function updateVals(i) {
      Object.keys(result).forEach((field) => {
        result[field] += i[`original_${field}`];
      });
    }

    params.api.getSelectedRows().length === 0
      ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
      : params.api.getSelectedRows().forEach((row) => updateVals(row));

    result.bookingId = "Total";
    setPinnedRow([result]);
    params.api.setPinnedBottomRowData([result]);
  }

  return (
    <GroupReportsWrapper
      reportName={`${t("Group Transfer Report")}`}
      columns={columns}
      reportActualType={"groupTransfersReport"}
      enableDateTypeFilters={false}
      createPinnedData={createPinnedData}
      pinnedRow={pinnedRow}
      selectedLanguage={props.selectedLanguage}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.hotels[0] };
}
export default connect(mapStateToProps)(GroupTransferReport);
